import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { UserDtoSchema } from '../contracts';

const ConfirmEmailChangeRequestDtoSchema = z.object({
  otp: z.string(),
});

const ConfirmEmailChangeResponseDtoSchema = UserDtoSchema;

export type ConfirmEmailChangeRequestDto = z.infer<
  typeof ConfirmEmailChangeRequestDtoSchema
>;
export type ConfirmEmailChangeResponseDto = z.infer<
  typeof ConfirmEmailChangeResponseDtoSchema
>;

export const confirmEmailChange = (
  dto: ConfirmEmailChangeRequestDto,
  config?: AxiosRequestConfig<ConfirmEmailChangeRequestDto>
) => {
  const data = ConfirmEmailChangeRequestDtoSchema.parse(dto);
  return api
    .post('/users/account/confirm-email-change', data, config)
    .then(responseContract(ConfirmEmailChangeResponseDtoSchema));
};
